module.exports = __webpack_public_path__ + "static/media/19ESCAP33.8df538c3.jpg";